module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root .Site_Layout":{"hooks.onStopRendering":[{"value":function () {
var pm = this.rwom1('@root #permissionManager');
var root = this._wom.getRoot();
var widget = root.wom1('#emailVerificationStatus');
if (!widget) {
widget = root.embedWidget('emailVerificationStatus', 'EmailVerificationNotify', {
'embed.container': '#notification-container',
getVerificationStateCb: function () {
if (fox.site.getEnv('userTokenExpired') === true)
return null;
if (!fox.isEmpty(pm.getMemberInfo()))
return !fox.isEmpty(pm.getMemberInfo('emailVerified'));
},
getUserEmailCb: function () {
return pm.getMemberInfo('email');
}
});
widget.run();
}
widget.showStripIdNeeded();
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101023},"path":"@root .Site_Layout","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/stripNotification.opt
// module id = 735
// module chunks = 4